export default function CategoryBar({ categories, active, onChange }) {
  const cats = ["All", ...categories];
  return (
    <div className="sticky top-[64px] z-20 bg-[#FBF6EE]/90 backdrop-blur border-b border-[#EFE7DA] mt-4">
      <div className="max-w-6xl mx-auto px-4 py-3 overflow-x-auto hide-scrollbar">
        <div className="flex gap-2 w-max">
          {cats.map((c) => {
            const isActive = c === active;
            return (
              <button
                key={c}
                data-testid={`category-tab-${c.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
                onClick={() => onChange(c)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? "bg-[#111111] text-white shadow-md" : "bg-white text-gray-700 border border-[#EFE7DA] hover:border-[#FF6600]"
                }`}
              >
                {c}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
